import React from "react";
import { getMediaCentralUrl } from "../services/media-service";
import type { Certification } from "../types";

interface StandaloneCertificationDisplayProps {
  certifications: Certification[];
  onCertificationSelect?: (
    certification: Certification,
    element?: HTMLElement,
  ) => void;
}

export const StandaloneCertificationDisplay: React.FC<
  StandaloneCertificationDisplayProps
> = ({ certifications, onCertificationSelect }) => {
  const certificationCount = certifications.length;

  const handleClick = (certification: Certification, element?: HTMLElement) => {
    if (onCertificationSelect) {
      onCertificationSelect(certification, element);
    }
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLDivElement>,
    certification: Certification,
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const target = event.currentTarget;
      handleClick(certification, target);
    }
  };

  return (
    <div className="standalone-certification">
      <h3 className="standalone-certification__title">
        Product Certification ({certificationCount})
      </h3>

      {certifications.map((certification, idx) => (
        <div key={idx} className="standalone-certification__item">
          <div className="standalone-certification__card">
            {certification.icon && (
              <div
                className="standalone-certification__icon"
                onClick={(e) => handleClick(certification, e.currentTarget)}
                onKeyDown={(e) => handleKeyDown(e, certification)}
                role="button"
                tabIndex={0}
                aria-label={`Learn more about ${certification.displayName}`}
              >
                <img
                  src={getMediaCentralUrl(
                    certification.icon.physicalId,
                    certification.icon.extension,
                  )}
                  alt=""
                  role="presentation"
                  className="standalone-certification__icon-image"
                />
              </div>
            )}

            <p className="standalone-certification__description">
              {certification.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
